import React from 'react';
import classnames from 'classnames';

import { SvgIconNames } from './icons-types';

type SvgProps = {
    name?: SvgIconNames;
    color?: 'blue' | 'primary-light' | 'white' | 'black' | 'secondary' | 'success' | 'failure' | 'grey' | 'orange';
    title?: string;
} & Omit<React.SVGProps<SVGSVGElement>, 'color' | 'name'>;

export const Svg: React.FC<SvgProps> = ({
    name,
    color,
    role,
    className,
    title,
    'aria-label': ariaLabel,
    'aria-hidden': ariaHidden,
    ...rest
}) => {
    const accessibleName = ariaLabel || title;
    const hasAccessibleName = Boolean(accessibleName);

    return (
        <svg
            className={classnames({
                ['svg']: true,
                [color ? `color--${color}` : '']: true,
                [className || '']: true,
            })}
            {...rest}
            role={hasAccessibleName ? (role ?? 'img') : undefined}
            aria-label={hasAccessibleName ? accessibleName : undefined}
            aria-hidden={hasAccessibleName ? ariaHidden : true}
        >
            {title ? <title>{title}</title> : null}
            <use xlinkHref={`#svg-${name}`} />
        </svg>
    );
};
